import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScoutPoint, ScoutPath } from '../../../core/models/scout-task';
import { ScoutTaskService } from '../../../core/services';
import { Point } from '../../../core/models';
import { timer } from 'rxjs';
import { AppState, ShowRequest } from '../../../core';

//
// Popup for clicking on marker
//
@Component({
  templateUrl: './scout-marker-popup.component.html',
  styleUrls: ['./scout-marker-popup.component.scss'],
  viewProviders: [ CommonModule]
})
export class ScoutMarkerPopupComponent implements OnInit {

  @Input() pt : ScoutPoint;
  @Input() selectedPt : ScoutPoint;
  @Input() scoutPath : ScoutPath
  @Input() buildingPoints : Point[]
  @Input() bShowSelectButton : boolean
  @Input() setSelectedPointFn : ( pt : ScoutPoint ) => void
  @Input() deleteScoutPointFn : ( pt : ScoutPoint ) => void
  @Input() newScoutPointFn : ( pt : ScoutPoint, offet: number ) => ScoutPoint
  @Input() allowEditMode : boolean = true
  @Input() changeGuard : (current: ScoutPoint, acceptFn: ()=>void) => void = (c,a) => a()
  @Input() showRefDataFn : ( pt : ScoutPoint ) => void
  @Input() locked : boolean
  //@Input() scoutPathChangedFn : () => void

  strLat : string
  strLng : string

  constructor( protected scoutTaskService : ScoutTaskService, protected appState: AppState ) {

  }
  
  ngOnInit() {
    this.strLat = this.pt.latitude ? Number(this.pt.latitude).toFixed(6) : ''
    this.strLng = this.pt.longitude ? Number(this.pt.longitude).toFixed(6) : ''
  }

  onDeleteScoutPoint = () => {
    console.log('onDeleteScoutPoint' + this.pt.name)
    this.deleteScoutPointFn(this.pt)
  }


  openExternalUrl(url:string) {
    if ( this.appState.isElectron() ) {
      const shell = window.require('electron').shell;
      shell?.openExternal(url)
    } else {
      window.open( url, `Scout Point ${this.pt.name}` );
    }
  }
  
  onShowGoogleMapsPoint(lat:string,lng:string) {
    this.openExternalUrl(`https://www.google.com/maps/place/${lat},${lng}/@${lat},${lng},21z`)
  }

  onSelectPoint = () => {
    console.log('onSelectPoint' + this.pt.name)
    this.setSelectedPointFn(this.pt)
  }

  onShowRefData = () => {
    this.showRefDataFn(this.pt)    
  }

  onShowPoint = ( pointId : string ) => {
    this.appState.showView.next( new ShowRequest('tab','point', pointId) )
  }

  onNewScoutPoint = () => {
    let offset = 1
    let newPt : ScoutPoint
    if ( this.newScoutPointFn ) {
      // plotter next to scout path segments editor uses this
      newPt = this.newScoutPointFn(this.pt,offset)
    } else {
      // ref modal uses this
      const ptIndex = this.scoutPath.scoutPoints.findIndex(pt=>pt.id == this.pt.id)
      const haPt = this.scoutTaskService.getScoutPathStartPoint(this.scoutPath)
      if ( haPt ) {
        const haIndex = this.scoutPath.scoutPoints.findIndex(pt=>pt.id == haPt.id)
        if ( haIndex >= 0 && ptIndex < haIndex ) {
          offset = 0 // for 'B' points, add before, for 'A' points add after.
        }
      }
      newPt = this.scoutTaskService.createScoutPointChild(this.pt,offset,'EX',this.scoutPath,this.buildingPoints);
    }
    this.scoutTaskService.updateScoutPathContext(this.scoutPath,this.buildingPoints)
    timer(0).subscribe(ms=>this.setSelectedPointFn(newPt))
  }

}